import { defineComponent } from "vue";
import { RouterLink } from "vue-router";
import { Container } from "aurelia-dependency-injection";
import { mapActions, mapState } from "pinia";

import { useApp } from "../../../../pages-vue/App/useApp";
import { IConversationNavOptions } from "../../../vue-interfaces/messaging-service/i-message";
import { AnalyticsCategory, AnalyticsService } from "../../../../services/analytics.service";
import { markdownToHtml } from "../../../../common/vue-helpers/modifiers/markdown-to-html-modifier";
import { sanitizeMarkup } from "../../../../common/vue-helpers/modifiers/value-modifier";
import { useConversationStore } from "../../../../pages-vue/MessageCenter/store/useConversationStore";
import { ChatNavOptionsEnum } from "../../../../enums/ChatNavOptionsEnum";
import {
    formatDateToLocalBasedOnDayMode,
    formatDisplayUsers
} from "../../../../common/vue-helpers/modifiers/format-message";

import Popover from "../../popover/popover.vue";
import AvaInitials from "../../../../pages-vue/MessageCenter/components/AvaInitials/AvaInitials.vue";

export default defineComponent({
    components: {
        RouterLink,
        Popover,
        AvaInitials
    },

    props: {
        isAxxessPlannerHeader: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            shakeMessageIcon: false,
            isLoading: true,
            _analyticsService: null as AnalyticsService,
            formatDisplayUsers,
            formatDateToLocalBasedOnDayMode,
            markdownToHtml,
            sanitizeMarkup
        };
    },

    created() {
        this._analyticsService = Container.instance.get(AnalyticsService);
    },

    computed: {
        ...mapState(useApp, ["loggedInUserDetails"]),
        ...mapState(useConversationStore, ["getAllUnreadConvs", "unreadConvIds"])
    },

    async mounted() {
        await this.getUnreadConversations();
        if (this.unreadConvIds.length > 0) {
            this.shakeMessageIcon = true;
        }
        setTimeout(() => (this.shakeMessageIcon = false), 1000);
    },

    methods: {
        ...mapActions(useConversationStore, ["getUnreadConversations", "removeUnreadConversation"]),

        handleMenuSelection(conversation: IConversationNavOptions) {
            this.$router.push({
                path: `/central-messaging/clinicians/conversation/${conversation.id}?tab=${ChatNavOptionsEnum.Chat}`,
                replace: true,
                force: true
            });
            this.removeUnreadConversation(conversation.id);
        },

        onUnreadMessages() {
            this._analyticsService.logEvent({
                category: AnalyticsCategory.Banners,
                action: "Unread Message Notification"
            });
        }
    }
});
